module.exports = __webpack_public_path__ + "img/icon-das-white.210288c7.svg";